import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment";
import * as Cookies from "es-cookie";
import './_attendance.scss';

const ADD_ATTENDANCE = gql`
  mutation($params: StudentAttendance) {
    addAttendance(params: $params)
  }
`;


class SubmitAttendanceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      submitError: "",
      loadingSpinner: 0,
    };
  }

  handleFormSubmit = e => {

    console.log("Attendance Type", this.props.stateData.attendanceSearchval.value)
    e.preventDefault();
    let studentDetails = [];
    this.props.stateData.getEducationalStudents.map((item) => {
      console.log("item123", item);
      studentDetails.push({ student_mobile: item.student_mobile, attendance_status: parseInt(item.value) })
    })
    let params = {
      attendance_type_id: parseInt(this.props.stateData.attendanceSearchval.value),
      inserted_time: moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString(),
      student_attendance: studentDetails,
      inserted_by: parseInt(Cookies.get("id")),
      class_id: parseInt(this.props.stateData.classSearchval.value)
    };
    console.log("params", params);

    this.setState({ loadingSpinner: 1 })
    this.addAttendance(params).catch(error => {
      console.log("catch if error");
      console.log(error);
      this.setState({
        submitError: error.graphQLErrors.map(x => x.message),
        loadingSpinner: 0
      });
      console.error(
        "ERR =>",
        error.graphQLErrors.map(x => x.message)
      );
      setTimeout(() => {
        this.props.onHide();
      }, 2000);
    });

  };

  addAttendance = async params => {
    console.log("child");
    await this.props.addAttendance({
      variables: {
        params
      },
      update: (store, { data }) => {
        if (data.addAttendance) {
          this.setState({
            currentStep: 5,
            loadingSpinner: 0
          });

          setTimeout(() => {
            this.SetpageLoad();
          }, 1500);
        }
      }
    });
  };

  SetpageLoad = () => {
    this.setState({ currentStep: 1, submitError: "" });
    this.props.onHide();
    this.props.clearAttendanceData()
    // this.props.onsubmit()
  };


  render() {
    console.log("time", moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString())

    return (
      <Modal
        {...this.props}
        size="md"
        aria-labelledby="example-modal-sizes-title-lg"
      // centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Student Attendance confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row>
            <Col>
              <h4>Total Students : </h4>
            </Col>
            <Col>
              <h4>{this.props.stateData.totalStudents}</h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <h6>Total Present :</h6>
            </Col>
            <Col>
              <h6>{this.props.stateData.no_of_present}</h6>
            </Col>
          </Row>
          <Row>
            <Col>
              <h6>Total Absent :</h6>
            </Col>
            <Col>
              <h6>{this.props.stateData.no_of_absent} </h6>
            </Col>
          </Row>
          <Row>
            <Col>
              <h6>Total Sick :</h6>
            </Col>
            <Col>
              <h6>{this.props.stateData.no_of_sick} </h6>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer variant="white" className="px-4">
          <Row>
            <Col sm={12}>
              {this.state.currentStep == 5 ? (
                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                  Attendance submitted successfully
                </Form.Text>
              ) : (
                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                  {this.state.submitError}
                </Form.Text>
              )}
            </Col>
          </Row>
          <Row>

            <Col sm={12}>
              <Button onClick={this.handleFormSubmit} className="get_btn"  type="submit" inline>
                {
                  this.state.loadingSpinner == 1 ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : ""
                }
                CONFIRM</Button>
            </Col>

          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}


export default graphql(ADD_ATTENDANCE, {
  name: "addAttendance"
})(SubmitAttendanceModal);


